// extracted by mini-css-extract-plugin
export var bannerShow = "banner-module--bannerShow--54XZf";
export var btn = "banner-module--btn--zgFdO";
export var btnBlock = "banner-module--btnBlock--QelMd";
export var btnBlockAdvantages = "banner-module--btnBlockAdvantages--hCEtk";
export var container = "banner-module--container--euIzb";
export var darkColor = "banner-module--darkColor--fseil";
export var fixBottom = "banner-module--fixBottom--JzVGD";
export var halvaMedia = "banner-module--halvaMedia--6bTFk";
export var hideMobBlock = "banner-module--hideMobBlock--A86Fy";
export var img = "banner-module--img--6RoC8";
export var mebelor = "banner-module--mebelor--J5qQG";
export var mobBtn = "banner-module--mobBtn--TeohS";
export var red = "banner-module--red--GfejP";
export var refinBlack = "banner-module--refinBlack--ayyNe";
export var secondContainer = "banner-module--secondContainer--WuaDq";
export var section = "banner-module--section--x7Paj";
export var subtitle = "banner-module--subtitle--bpd0S";
export var text = "banner-module--text--cA-IB";
export var textBlockContainer = "banner-module--textBlockContainer--6R0-s";
export var textItem = "banner-module--textItem--eZKqE";
export var title = "banner-module--title--30cDo";
export var wrapper = "banner-module--wrapper--oEiLu";